var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIkonCustomers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-name": "Group 26784"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26354"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.745 21.792c-1.158 0 11.863-.093-.7 0 0 3.051 2.978 5.526 6.657 5.526s6.662-2.474 6.662-5.526c0-.124.113-.034-.407-.118-.85-.055-9.874.118-12.212.118Z",
    "data-name": "Path 24319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.761 18.661H.65c.061.206-.184.083.621 0 .113 0 1.56-.035 3.861 0 5.848.26-1.959-.112 24.716 0 .808.01 2.005.056 2.913 0 .045-.014-.194-.133 0 0h0l-1.378 4.241h0a3.482 3.482 0 0 0-3.377 4.648h0l-3.607 2.621h0a3.482 3.482 0 0 0-5.464 1.775h-4.459a3.481 3.481 0 0 0-5.463-1.775h0L5.406 27.55h0a3.482 3.482 0 0 0-3.377-4.648h0L.651 18.661Z",
    "data-name": "Path 24320"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26781"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26778",
    transform: "translate(9.815 .65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17.743c.147-4.6 3.193-8.293 6.942-8.293a6.287 6.287 0 0 1 4.915 2.534 9.615 9.615 0 0 1 2.027 5.773",
    "data-name": "Path 24321"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.985,
    cy: 3.799,
    "data-name": "Ellipse 635",
    rx: 2.985,
    ry: 3.799,
    transform: "translate(3.957)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26779",
    transform: "translate(2.963 1.96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.414 10.054C9.23 9.745 8.731 7.72 5.646 7.72a4.929 4.929 0 0 0-4.045 2.69 12.175 12.175 0 0 0-1.668 6.129",
    "data-name": "Path 24321"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.44,
    cy: 3.104,
    "data-name": "Ellipse 635",
    rx: 2.44,
    ry: 3.104,
    transform: "translate(3.233)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26780",
    transform: "translate(20.963 1.96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.139 10.016c.1-.292.693-2.294 3.756-2.294a4.894 4.894 0 0 1 4.012 2.674 12.125 12.125 0 0 1 1.656 6.1",
    "data-name": "Path 24321"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.44,
    cy: 3.104,
    "data-name": "Ellipse 635",
    rx: 2.44,
    ry: 3.104,
    transform: "translate(1.456)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonCustomers);
export default __webpack_public_path__ + "static/media/Ikon_Customers.02a5bf79c74fe4c14c7997cc3772d8dd.svg";
export { ForwardRef as ReactComponent };